<template>

    <div class="layout__container text__align-center">
        <div class="layout__padding-20-0">
        <h3 class="">Our records indicate that your account is currently on hold.</h3>
        </div>

        <h3 class="">Please contact our team who will be happy to advise and enable you to place your order
            again.</h3>

        <div class="layout__padding-20-0">
            <p>Ravensworth Client Services:</p>
            <p class="text__colour-teal">0191 917 9331</p>
            <p class="text__colour-teal">client.support@ravensworth.co.uk</p>
        </div>
    </div>

</template>

<script>

    export default {
        name: "onhold",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {}
    };
</script>